import { useUserInfo } from "GlobalStates/User";
import { Navigate, useNavigate } from "react-router-dom";
import { ROUTES } from "Features/Routes/routeConstants";
import { useTemporaryToken } from "GlobalStates/temporaryToken";
import { TermsPoliciesModal } from "Components/TermsPoliciesModal/TermsPoliciesModal";
import { usePolicyGate } from "Features/Policies/usePolicyGate";
import apiClient from "QueryClient/axiosClient";
import { useMutation } from "@tanstack/react-query";

export const ProtectedRoute = ({ children }) => {
  const { user, setUser } = useUserInfo();
  const navigate = useNavigate();
  const { loading, needsAcceptance, requiredPolicy, accepting, handleAccept } =
    usePolicyGate();

  const logoutUserMutation = useMutation({
    mutationFn: () => {
      return apiClient.post("/auth/logout");
    },
    onSuccess: () => {
      setTimeout(() => {
        navigate(ROUTES.HOME);
        setUser(() => ({
          token: "",
          tier: "",
          completedCollegeFinder: false,
          name: "",
          picture: "",
          id: "",
          email: "",
        }));
      }, 3000);
    },
    onError: (error) => {
      console.error("Logout failed:", error);
      setUser(() => ({
        token: "",
        tier: "",
        completedCollegeFinder: false,
        name: "",
        picture: "",
        id: "",
        email: "",
      }));
      navigate(ROUTES.HOME);
    },
  });

  if (!user || !user?.token) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  if (loading) {
    return null;
  }
  if (needsAcceptance) {
    return (
      <TermsPoliciesModal
        open={true}
        onAccept={handleAccept}
        onCancel={() => {
          setUser({
            token: "",
            name: "",
            tier: "",
            completedCollegeFinder: false,
            picture: "",
            id: "",
            email: "",
          });
          logoutUserMutation.mutate();
        }}
        loading={accepting}
        policyVersion={requiredPolicy?.policyVersion}
        effectiveDate={requiredPolicy?.effectiveDate}
        documentUrl={requiredPolicy?.documentUrl}
      />
    );
  }
  return children;
};

export const TemporaryProtectedRoute = ({ children }) => {
  const { token } = useTemporaryToken();
  if (!token) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return children;
};
